import * as React from 'react';
import clsx from 'clsx';
import { getContainerIcon, ObjectsHelper } from 'utils';
import { AutoScrollbars, BannerAerlo, Checkbox } from 'components';
import { isObjectFilesArray } from 'types/omjs/type-checkers';
import { IContainer } from 'types/omjs/project';
import { actions as containersActions } from 'services/containers/containers-service';

import './style.scss';

export interface IMobileUIObjectInfoProps {
    object: omjs.IObjectJSON;
    structure: ObjectsHelper.IModifiedStructureColumn[];
    layerConfig: omjs.ILayerConfig;
    className?: string;
    withBanner?: boolean;
    withConnections?: boolean;
    containers?: IContainer[],
    t: (key: string, options?: any) => string
}

export interface IMobileUIObjectInfoState {}

export class MobileUIObjectInfoComponent extends React.Component<IMobileUIObjectInfoProps, IMobileUIObjectInfoState> {
    private columnsElementsMap: Map<ObjectsHelper.IModifiedStructureColumn, HTMLTableRowElement> = new Map();
    private wrapperRef = React.createRef<HTMLDivElement>();
    private scrollerRef = React.createRef<AutoScrollbars>();

    constructor(props: IMobileUIObjectInfoProps) {
        super(props);

        this.renderTableRow = this.renderTableRow.bind(this);
    }

    public scrollToColumn(column: ObjectsHelper.IModifiedStructureColumn) {
        let el = this.columnsElementsMap.get(column);

        if (!el) {
            console.log('Не нашли колонки', column);
            return;
        }

        this.scrollerRef.current.getScrollElement().scrollTop = (
            el.offsetTop - this.scrollerRef.current.getScrollElement().offsetTop
        );
    }

    renderCommunications() {
        const { containers, t } = this.props;
        const powerCode = 'ia34';
        const gasCode = 'ii_obj_gazosnabzh_new';
        const waterSupplyCode = 'water_supply';
        const sewerageCode = 'sewerage';

        const communications = containers
            .filter(c => [ gasCode, powerCode, waterSupplyCode, sewerageCode ].includes(c.code))
            .map((c) => (
                <div className="communication-item" key={c.id}>
                    <Checkbox
                        checked={c.selected}
                        onChange={() => containersActions.setContainerSelected({
                            id_or_code: c.id, selected: !c.selected
                        })}
                    />
                    <div className="communication-icon-wrapper">
                        <img src={getContainerIcon(c)} />
                    </div>
                    <div className="communication-name">
                        {c.name}
                    </div>
                </div>
            ));

        return (
            <div className="mobile-ui-communications">
                <div className="mobile-ui-communications-title">
                    {t('Отобразить возможность подключения на карте')}
                </div>
                <div className="mobile-ui-communications">
                    {communications}
                </div>
            </div>
        );
    }

    private renderTableRow(
        item: ObjectsHelper.IModifiedStructureColumn,
        index: number,
        structure: ObjectsHelper.IModifiedStructureColumn[]
    ) {
        let { object } = this.props;
        if (!item.name) return null;
        // let value = (object[`#${item.code}`] || object[item.code]).replace(/\s+\|\s+/g, '; ');
        let value = (object.fields[`#${item.code}`] || object.fields[item.code]) || '';
        let is_title = item.type === 'title';

        if (typeof value === 'string') {
            value = value.replace(/\n/ig, '<br />');
        }

        let next_item = structure[index + 1];
        let is_last = next_item?.level === 0 ?? false;

        if (!is_title && !value) {
            return null;
        }

        if (item.level === 0) {
            return (
                <React.Fragment key={item.code}>
                    <tr
                        ref={(el) => {
                            this.columnsElementsMap.set(item, el);
                        }}
                        className={clsx(
                            'row',
                            'row-header',
                            'is-title',
                            {
                                // 'is-title': is_title,
                                'is-last': is_title && is_last
                            }
                        )}
                    >
                        <td colSpan={2}>
                            {item.name}
                        </td>
                    </tr>
                    {
                        !is_title && (
                            <tr
                                className={clsx(
                                    'row',
                                    'row-value',
                                    {
                                        'is-last': is_last
                                    }
                                )}
                            >
                                <td
                                    colSpan={2}
                                    dangerouslySetInnerHTML={{
                                        __html: value.toString()
                                    }}
                                />
                            </tr>
                        )
                    }
                </React.Fragment>
            );
        } else {
            return (
                <tr
                    className={clsx(
                        'row',
                        `level-${item.level}`,
                        { 'is-last': is_last }
                    )}
                    key={item.code}
                >
                    <td
                        className={clsx('name', is_title && 'is-title')}
                        colSpan={is_title ? 2 : 1}
                    >
                        {item.name}
                    </td>

                    {!is_title && (
                        <td className="value">
                            {
                                isObjectFilesArray(value)
                                    ? (
                                        value.map(file => (
                                            <div key={file.id}>
                                                <a href={file.path}>{file.name}</a>
                                            </div>
                                        ))
                                    )
                                    : (
                                        <span dangerouslySetInnerHTML={{
                                            __html: value
                                                .toString()
                                                .split('\n')
                                                .join('<br />')
                                        }}
                                        />
                                    )
                            }
                        </td>
                    )}
                </tr>
            );
        }
    }

    render() {
        let { structure, object, withBanner, withConnections } = this.props;
        return (
            <AutoScrollbars ref={this.scrollerRef} className={this.props.className}>
                {withConnections && this.renderCommunications()}
                <div className='mobile-ui-section-info' ref={this.wrapperRef}>
                    <table>
                        <tbody>
                            {structure.map(this.renderTableRow)}
                        </tbody>
                    </table>
                </div>
                {withBanner && (
                    <div className="mobile-ui-banner-wrapper">
                        <BannerAerlo />
                    </div>
                )}
            </AutoScrollbars>
        );
    }
}

export const MobileUIObjectInfo = MobileUIObjectInfoComponent;
